export default __webpack_public_path__ + "static/media/icon-complete.ff71e7a0.svg";